/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { Link } from "react-router-dom";
import BaseCom from "./BaseCom";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import Icon from "./Icon";
import Alert from "./Alert";

class MyDay extends BaseCom {

    componentDidMount() {
        this.fillList('/api/visit/my/list', 'list');
    }

    render() {
        return <div className="container-fluid pb-3">
            <h1 className="d-flex align-items-center">
                <div className="flex-fill">My Day</div>
                <small className="d-block me-3">Only shows encounters assigned to you.</small>
            </h1>
            {this.state.list?.map(i => <Link key={i.id} to={'/visit/view/' + i.id} role="button" className={'d-block rounded data-link drop-shadow bg-light p-3 mt-2 d-flex align-items-center' + (i.claimed ? ' claimed' : '')}>
                <div className="flex-fill">
                    <h5>{i.patient.fullName}</h5>
                    {i.patient.isLead && <small className="text-muted"><Icon icon="faExclamationTriangle" /> This patient is still in queue.</small>}
                    <div>DoB: <strong>{i.patient.birthDate ?? 'Unknown'}</strong></div>
                    {i.claimed && <div className="text-success"><Icon icon="faStar" /> Visited</div>}
                </div>
                <div>City: {i.city} {i.lat !== 0 && i.lng !== 0 && i.lat !== -1 && i.lng !== -1 && <a href={'https://www.google.com/maps/search/?api=1&query=' + i.lat + ',' + i.lng} target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()} className="btn btn-lg btn-secondary"><Icon icon="faMapPin" /></a>}</div>                
            </Link>)}
            {this.state.list && this.state.list.length === 0 && <Alert type="info" message="No visits assigned to you." />}
        </div>;
    }
}

export default withParamsAndNavigate(MyDay);